<div class="map-single-text-container">

    <!-- Content -->
    <div *ngIf="isEditable || text != ''">
        <!-- Edit Icon -->
        <button class="edit-icon-btn" *ngIf="isEditable && !isEditing" (click)="toggleEdit()" title="Edit text">
            <i class="fa-solid fa-edit"></i>
        </button>

        <!-- Display Mode -->
        <div class="text-display" *ngIf="!isEditing">
            <div class="text-content" [innerHTML]="text" *ngIf="text"></div>
            <div class="empty-state" *ngIf="!text">
                <i class="fa-solid fa-file-text"></i>
                <span>No text content available</span>
                <button class="btn-add-text" *ngIf="isEditable" (click)="startEdit()">
                    <i class="fa-solid fa-plus"></i>
                    Add Text
                </button>
            </div>
        </div>

        <!-- Edit Mode -->
        <div class="text-editor" *ngIf="isEditing">
            <div class="editor-header">
                <span class="editor-title">Edit Text</span>
                <div class="editor-actions">
                    <button class="btn-save" (click)="saveText()" [disabled]="isSaving" title="Save">
                        <i class="fa-solid fa-spinner fa-spin" *ngIf="isSaving"></i>
                        <i class="fa-solid fa-check" *ngIf="!isSaving"></i>
                    </button>
                    <button class="btn-cancel" (click)="cancelEdit()" [disabled]="isSaving" title="Cancel">
                        <i class="fa-solid fa-times"></i>
                    </button>
                </div>
            </div>
            <app-editor [(innerValue)]="editedText"></app-editor>
        </div>
    </div>
</div>